import { render } from "./CookieAcceptDecline.vue?vue&type=template&id=5c12126d"
import script from "./CookieAcceptDecline.vue?vue&type=script&lang=js"
export * from "./CookieAcceptDecline.vue?vue&type=script&lang=js"

import "./CookieAcceptDecline.vue?vue&type=style&index=0&id=5c12126d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__